import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Keycloak from "keycloak-js";
import SecurityContext from "./SecurityContext";
import ruMessages from "devextreme/localization/messages/ru.json";
import {locale, loadMessages} from "devextreme/localization";
import {applyMiddleware, createStore, combineReducers, compose} from "redux";
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import {
  createMuiTheme,
  responsiveFontSizes,
  ThemeProvider
} from "@material-ui/core/styles";

import dictAll from "./Dict/store/reducer";
import {reducer as dictDocCategoryView} from "./Dict/DocCategory/View/reducer";
import {reducer as dictDocTypeView} from "./Dict/DocType/View/reducer";
import {reducer as dictRegionView} from "./Dict/Region/View/reducer";
import {reducer as dictMunicipalView} from "./Dict/Municipal/View/reducer";
import {reducer as dictWorldSkillCategoryView} from "./Dict/WorldSkillCategory/View/reducer";
import {reducer as dictWorldSkillTypeView} from "./Dict/WorldSkillType/View/reducer";
import {reducer as dictWorldSkillStatusView} from "./Dict/WorldSkillStatus/View/reducer";
import {reducer as dictWorldSkillView} from "./Dict/WorldSkill/View/reducer";
import {reducer as dictLegalFormView} from "./Dict/LegalForm/View/reducer";
import {reducer as dictPersonSkillStateView} from "./Dict/PersonSkillState/View/reducer";
import {reducer as dictRolesView} from "./Dict/Roles/View/reducer";
import {reducer as personView} from "./Person/View/reducer";

import {reducer as ui} from "./ui/uiModule";
import {reducer as me} from "./Me/store/reducer";
import {reducer as constructorIndex} from "./Constructor/Index/reducer";
import {reducer as dashboardView} from "./Dashboard/reducer";
import {reducer as manageOOPResourcesIndex} from "./ManageOOP/Resources/Index/reducer";
import {reducer as manageOOPResourcesOrganizationsIndex} from "./ManageOOP/Resources/Organizations/Index/reducer";
import {reducer as manageOOPResourcesMatTechIndex} from "./ManageOOP/Resources/MatTech/Index/reducer";
import {reducer as manageOOPResourcesOpModIndex} from "./ManageOOP/Resources/OpMod/Index/reducer";
import {reducer as manageOOPResourcesFGOSIndex} from "./ManageOOP/Resources/DictCompetFGOS/Index/reducer";

import {composeWithDevTools} from "redux-devtools-extension";
import facilities from "./Facility/store/reducer";
import persons from "./ManageOOP/Resources/Person/store/reducer";
import programs from "./ManageOOP/Resources/OpMod/MyOPMod/store/reducer";
import masterClasses from "./ManageOOP/Resources/OpMod/MasterClass/store/reducer";
import nomenclature from "./ManageOOP/Resources/MatTech/Nomenclature/store/reducer";
import specialities from "./Dict/Skills/Speciality/store/reducer";
import skillCounter from "./Dict/Skills/DictSkills/reducer";
import skill from "./Dict/Skills/Skill/store/reducer";
import modules from "./Constructor/Module/store/reducer";
import skillConstruct from "./Constructor/Competence/store/reducer";
import programConstruct from "./Constructor/Program/store/reducer";
import expertise from "./Constructor/Expert/store/reducer";
import dictLists from "./Dict/Lists/store/reducer";
import studyPlan from "./Study/Plan/store/reducer";
import studyGroups from "./Study/Groups/store/reducer";
import studyRequests from "./Study/Requests/store/reducer";
import studyStudents from "./Study/Students/store/reducer";
import dialog from "./Dialog/store/reducer";
import organizations from "./Organizations/store/reducer";
import manageQuiz from "./Quiz/ManageQuiz/store/reducer";
import enjoyQuiz from "./Quiz/EnjoyQuiz/store/reducer";

const rootReducer = combineReducers({
  dashboardView,
  constructorIndex,
  manageOOPResourcesIndex,
  manageOOPResourcesOrganizationsIndex,
  manageOOPResourcesMatTechIndex,
  manageOOPResourcesOpModIndex,
  manageOOPResourcesFGOSIndex,
  dictAll,
  dictDocCategoryView,
  dictDocTypeView,
  dictRegionView,
  dictMunicipalView,
  dictWorldSkillCategoryView,
  dictWorldSkillTypeView,
  dictWorldSkillStatusView,
  dictWorldSkillView,
  dictLegalFormView,
  dictRolesView,
  dictPersonSkillStateView,
  personView,
  organizations,
  facilities,
  persons,
  programs,
  masterClasses,
  nomenclature,
  specialities,
  skillCounter,
  skill,
  skillConstruct,
  programConstruct,
  expertise,
  dictLists,
  ui,
  me,
  modules,
  studyPlan,
  studyGroups,
  studyRequests,
  studyStudents,
  dialog,
  manageQuiz,
  enjoyQuiz
});

// const middlewares = [thunk, logger];
const middlewares = [thunk];
const devTools =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(...middlewares)
    : composeWithDevTools(applyMiddleware(...middlewares));

const store = createStore(rootReducer, devTools);

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_BASE_URI,
  realm: "copp-work",
  clientId: "copp-work-site"
});
const security = {
  keycloak: keycloak,
  profile: {},
  hRefreshInterval: null,
  hasRole: role => keycloak.hasRealmRole(role),
  logout: () => {
    if (security.hRefreshInterval) {
      clearInterval(security.hRefreshInterval);
    }
    document.cookie = "AccessToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    return keycloak.logout();
  }
};

const theme = createMuiTheme({
  palette: {
    success: {
      light: '#d0e7b7',
      main: '#4caf50',
      dark: '#357a38',
      contrastText: '#fff',
    },
    danger: {
      light: '#ea8f8f',
      main: '#ef5350',
      dark: '#aa2e25',
      contrastText: '#fff',
    }
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    body1: {
      fontSize: 12
    }
  }
});

keycloak.init({onLoad: "login-required", "checkLoginIframe": false}).success(() => {
  let cookieValue = keycloak.token;
  let cookieName = "AccessToken";
  let cookieExpire = new Date();
  cookieExpire.setMinutes(cookieExpire.getMinutes() + 5);
  document.cookie =
    cookieName + "=" + cookieValue + ";expires=" + cookieExpire + ";path=/";
  security.hRefreshInterval = setInterval(() => {
    console.log("Refreshing token");
    keycloak
      .updateToken(30)
      .success(refreshed => {
        if (refreshed) {
          console.log("New access token");
          let cookieValue = keycloak.token;
          let cookieName = "AccessToken";
          let cookieExpire = new Date();
          cookieExpire.setMinutes(cookieExpire.getMinutes() + 5);
          document.cookie =
            cookieName +
            "=" +
            cookieValue +
            ";expires=" +
            cookieExpire +
            ";path=/";
        } else {
          console.log("Access token still valid");
        }
      })
      .error(err => {
        console.error(err);
      });
  }, 60000);

  keycloak.loadUserProfile().success(profile => {
    loadMessages(ruMessages);
    locale("ru-RU");
    security.profile = profile;
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <SecurityContext.Provider value={security}>
            <App/>
          </SecurityContext.Provider>
        </Provider>
      </ThemeProvider>,
      document.getElementById("root")
    );
  });
});
